import { Component, OnInit, Renderer2, AfterViewInit } from '@angular/core';
import { LangService } from './shared/lang.service';
import { environment } from '../environments/environment';
import { Injectable } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale, frCaLocale } from 'ngx-bootstrap/locale';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})

@Injectable()
export class AppComponent implements OnInit, AfterViewInit {
  isMultiColorActive = environment.isMultiColorActive;
  constructor(private langService: LangService, private renderer: Renderer2, private bsLocaleService: BsLocaleService) {
    defineLocale('en-us', enGbLocale);
    defineLocale('fr-ca', frCaLocale);
    this.bsLocaleService.use((localStorage.getItem('__lang') || 'en-US').toLowerCase());
  }

  ngOnInit() {
    this.langService.init();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.renderer.addClass(document.body, 'show');
    }, 1000);
    setTimeout(() => {
      this.renderer.addClass(document.body, 'default-transition');
    }, 1500);
  }
}
